document.addEventListener("DOMContentLoaded", () => {
  handleSortingOptionChange();
});

function handleSortingOptionChange() {
  const sortingSelect = [...document.querySelectorAll('.boost-pfs-filter-top-sorting')];

  sortingSelect.forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location);
      
      if (select.value === 'created-descending') {
        setTimeout(() => {
          url.searchParams.set("sort", "created-descending");
          history.pushState({}, "", url);
        }, 1000);
        
        return;
      }

      if (select.value === 'best-selling') {
        setTimeout(() => {
          url.searchParams.set("sort", "best-selling");
          history.pushState({}, "", url);
        }, 1000);
        
        return;
      }
    })
  });
}